export default {
  CLOSE_ROLL_BOOK(state) {
    state.isViewRollBook = false;
  },
  TOGGLE_ROLL_BOOK(state) {
    state.isViewRollBook = !state.isViewRollBook;
  },
};
